import { nanoid } from "nanoid"
import NotificationsByDay from "./NotificationsByDay"
import NotificationsByMonthTitle from "./NotificationsByMonthTitle"

import "../style.scss"

const NotificationsByMonth = ({ data }: $TSMigrationFixMe) => {
  return (
    <div className='text-left d-flex flex-column'>
      <div className='notifications-list-by-month d-flex flex-column'>
        <NotificationsByMonthTitle title={data.month} />
        {data.items.map((dayNotifications: $TSMigrationFixMe) => (
          <NotificationsByDay
            key={nanoid()}
            data={dayNotifications}
          />
        ))}
      </div>
    </div>
  )
}

export default NotificationsByMonth
